import { api } from "./config";

// Manual package edit/cancel requests requiring admin approval — see
// backend/routes/packageChangeRequest.js. Submitted by roles that have the
// new /api/package-change-request permission (e.g. "manager") but not direct
// /api/package or /api/package-cancel access; approved/rejected by admin.

export async function SubmitPackageEditRequest(packageId, proposedFields, reason) {
  try {
    const response = await api().post("/package-change-request", {
      packageId,
      actionType: "edit",
      reason,
      ...proposedFields,
    });
    return response.data;
  } catch (error) {
    if (error.response) return error.response.data;
    throw error;
  }
}

export async function SubmitPackageCancelRequest(packageId, reason, note) {
  try {
    const response = await api().post("/package-change-request", {
      packageId,
      actionType: "cancel",
      reason,
      note,
    });
    return response.data;
  } catch (error) {
    if (error.response) return error.response.data;
    throw error;
  }
}

export async function UploadPackageChangeRequestEvidence(requestId, files) {
  const formData = new FormData();
  files.forEach((file) => formData.append("evidence", file));
  try {
    const response = await api().post(`/package-change-request/${requestId}/evidence`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    if (error.response) return error.response.data;
    throw error;
  }
}

export async function ListPackageChangeRequests(params = {}) {
  try {
    const response = await api().get("/package-change-request", { params });
    return response.data;
  } catch (error) {
    if (error.response) return error.response.data;
    throw error;
  }
}

export async function GetPackageChangeRequest(id) {
  try {
    const response = await api().get(`/package-change-request/${id}`);
    return response.data;
  } catch (error) {
    if (error.response) return error.response.data;
    throw error;
  }
}

export async function ApprovePackageChangeRequest(id) {
  try {
    const response = await api().patch(`/package-change-request/${id}/approve`);
    return response.data;
  } catch (error) {
    if (error.response) return error.response.data;
    throw error;
  }
}

export async function RejectPackageChangeRequest(id, rejectionReason) {
  try {
    const response = await api().patch(`/package-change-request/${id}/reject`, { rejectionReason });
    return response.data;
  } catch (error) {
    if (error.response) return error.response.data;
    throw error;
  }
}
